import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {BzAlertComponent} from './alert.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import {BzAlertService} from './alert.service';
import {BzAlertActions} from './core/reducers/alert.actions';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserModule,
    CommonModule,
    AlertModule.forRoot(),
  ],
  declarations: [
    BzAlertComponent
  ],
  exports: [
    BzAlertComponent
  ],
  providers: [
    BzAlertService,
    BzAlertActions
  ],
})
export class BzAlertModule { }
